import React from 'react';
import MatchList from '../common/MatchList';

export default function Results(props) {
  return (
    <MatchList
      {...props}
      subtitle="Results"
      emptyMessage="No recent results."
    />
  );
}
